import { useMutation, useQuery } from '@tanstack/react-query';
import { orderRequestsClient } from 'api';
import type {
  PublicGetOrderRequestDataQueryResult,
  PublicOrderRequestToAdd
} from 'api/models/mainservice';
import type { ApiError } from 'common/models';
import { EXPIRED_LINK, handleApiError } from 'helpers/errorHandling';

const publicOrderRequestKey = 'publicOrderRequest';
export const getPublicOrderRequestQueryKeyBuilder = () => [publicOrderRequestKey];

export const useGetPublicOrderRequestQuery = (
  tenantCode: string,
  publicFormCode: string,
  expiredError: (error: string) => void
) => {
  return useQuery<PublicGetOrderRequestDataQueryResult, ApiError>(
    getPublicOrderRequestQueryKeyBuilder(),
    () => orderRequestsClient.getPublicOrderRequestData(tenantCode, publicFormCode),
    {
      onError: (error) => {
        handleApiError(error);
        if (error.response?.status === 404) {
          return expiredError(EXPIRED_LINK);
        }

        return error;
      },
      refetchOnWindowFocus: false
    }
  );
};

export const useAddPublicOrderRequestMutation = () => {
  return useMutation<
    undefined,
    ApiError,
    { tenantCode: string; publicFormCode: string; requestToAdd: PublicOrderRequestToAdd }
  >(orderRequestsClient.addOrderRequestData);
};
